import {get as getCookie, set as setCookie} from 'es-cookie';
import {isHomepage, getMetaValue, isInIframe} from '../../../../utilities/utils';

const device = navigator && navigator.userAgent && typeof navigator.userAgent == "string"
                ? navigator.userAgent.match(/android/gi) && navigator.userAgent.match(/rai24/gi)
                    ? 'android'
                    : navigator.userAgent.match(/ios/gi) && navigator.userAgent.match(/rai24/gi)
                        ? 'ios'
                        : 'browser'
                :'browser';

const frequencyInSeconds = 30;
export function getAdvLabelFromPage(vendor){

    let isTgr = !!getRegionNameByUrl();

    switch (getDomain()){
        case ('raiplaysound'):
        case ("raiplay") :
            if(!!window.rai_adv && !!window.rai_adv.adv_label) return window.rai_adv.adv_label;
            if(!!window.rai_adv && !!window.rai_adv.dfp && !!window.rai_adv.dfp.label) return window.rai_adv.dfp.label;
            if(isHomepage()) return 'hompg';
            if(isNativePage()) return 'hompg';
            if(document.body.classList.contains('my-list-page')) return 'lmlst';
            return 'genrc/'+getAdvPortalCode();
        case ("rainews") :
        case ("rai24") :
            if(!!window.rai_adv && !!window.rai_adv.adv_label) return vendor == 'google' ? 'sezio/' + window.rai_adv.adv_label : window.rai_adv.adv_label; /* Override da categorie tematica o storie */
            if(vendor !== 'google' && isTgr) return 'teleg';
            if(getMetaAttr("pageType", "notiziario")) return vendor == 'google' ? 'sezio/teleg' : 'teleg'; /* Tutte pagine e foglie */
            if(getMetaAttr("pageType", "homepage"))return vendor == 'google' ? 'sezio/hpage' : 'hpage'; /* Su nazionale */
            return vendor == 'google' ? 'sezio/newsx' : 'newsx';
    }
}
export function isNativePage(){
    return document.body.classList.contains('rai-native');
}
export function getAdvPortalCode() {
  let portalCode = 'rplyw';
  switch (getDomain()) {
      case 'raiplaysound':
          portalCode = 'rplsw';
          break;
      case 'raiplay':
          portalCode = 'rplyw';
          break;
      case 'rainews':
          portalCode = device != 'browser' ? 'rnwsa' : 'rnwsm' ;
          break;
      case 'rai':
          if (isInIframe() && document.referrer.indexOf("msn.com") > -1) {
              portalCode = 'rplyw';
          } else {
            portalCode = 'raitw';
          }
          break;
      case 'raisport':
          portalCode = 'rsptw';
          break;
  }
  return portalCode;
}
export function getNetworkCode(){
    return document.location.search == '?test=Rai24' ? '21690435817' : '21704543449';   /**check to remove after test*/
}
export function getDomain(){
    let domain = document.domain.indexOf("www.") > -1 ? document.domain.split(".")[1] : document.domain.split(".")[0];
    domain = domain.split("-")[0]; 
    return domain;
}
export function isAdvLiveEnabled(){
    /*ovveride temporaneo per disabilitare frequency_cap su dirette per Fiorello*/
    return true;
    if (getCookie('noadv-diretta')) {
        //se esiste il cookie disabilita adv su live
        return false;
    } else {
        var durataCookie = (1 / 24 / 60 / 60) * frequencyInSeconds;
        setCookie('noadv-diretta', true, {expires:durataCookie});
        return true;
    }
}

export function getRegionNameByUrl() {
    const regex = /(?:.*?tgr\/)([^\/?]+)(?:.*)/m;
    const matches = window.location.pathname.match(regex);
    let regioneNameByUrl = matches?.length ? matches[1] : null;

    if (regioneNameByUrl) {
      switch (regioneNameByUrl) {
        case 'fvg':
          regioneNameByUrl = 'friuliveneziagiulia'
          break;
        case 'vda':
          regioneNameByUrl = 'valledaosta'
          break;
        case 'fjk':
          regioneNameByUrl = 'furlanijajulijskakrajina'
          break;
      }
    }

    return regioneNameByUrl;
}

export function getMetaAttr(meta, content) {
    var metas = document.getElementsByTagName('meta');
    for (var i = 0; i < metas.length; i++) {
        if ((metas[i].getAttribute("name") == meta || metas[i].getAttribute("property") == meta) && metas[i].getAttribute("content") == content) {
        return metas[i].getAttribute("content");
        }
    }
    return false;
}